/**
 * Field Operations Container Module Configuration
 *
 * Groups field safety and jobsite modules (including Toolbox Talks)
 * under a dedicated "Field Operations" top-level sidebar section.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const fieldOperationsModule: AppModule = {
    id: 'field-operations',

    navigation: {
        label: 'Field Operations',
        icon: 'hard-hat',
        path: '/toolbox-talks',
        order: 78,
        moduleKey: 'toolbox_talks',
        pages: [
            {
                label: 'Toolbox Talks',
                path: '/toolbox-talks',
                icon: 'hard-hat',
                moduleKey: 'toolbox_talks',
            },
        ],
    },

    routes,
}

export default fieldOperationsModule
